module.exports = __webpack_public_path__ + "static/image/logo-family/logo_robot@3x.png?3429acdf";